export default __webpack_public_path__ + "static/Solving-Problems-Efficiently-With-MMS-d7fb47ba819949f900de7c6d354fb2dd.webp";